import { jsx, jsxs } from "react/jsx-runtime";
import PlusCircle from "@crehana/compass.icons.outline/PlusCircle";
import Trash2 from "@crehana/compass.icons.outline/Trash2";
import { useTranslation } from "@crehana/i18n";
import clsx from "clsx";
import { Button } from "../Button/index.js";
import i18n from "./i18n/index.js";
function ListActionsLayout({ items, canAdd, canDeleteAll, onItemChange, onAddItem, onDeleteItem, onDeleteAll, children, className, footerActions }) {
    const { languageCode } = useTranslation();
    return /*#__PURE__*/ jsxs("section", {
        className: clsx('tw-w-full tw-space-y-1', className),
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: "tw-w-full tw-p-1.2 tw-bg-neutral-light-300 tw-rounded-1.2",
                children: [
                    items.map((item, index)=>/*#__PURE__*/ jsx("div", {
                            children: children({
                                onChange: (value)=>onItemChange(value, index),
                                onDelete: ()=>onDeleteItem(index),
                                defaultValue: item.value
                            })
                        }, item.id)),
                    /*#__PURE__*/ jsxs("div", {
                        className: "tw-flex tw-items-center tw-justify-between",
                        children: [
                            /*#__PURE__*/ jsxs(Button, {
                                type: "button",
                                variant: "cancel",
                                className: clsx(canAdd ? '!tw-text-primary-light-500' : '!tw-text-neutral-light-500 tw-opacity-50 tw-pointer-events-none'),
                                onClick: onAddItem,
                                children: [
                                    /*#__PURE__*/ jsx(PlusCircle, {
                                        size: 20,
                                        className: "tw-text-current"
                                    }),
                                    i18n[languageCode].ADD_ITEM
                                ]
                            }),
                            /*#__PURE__*/ jsxs(Button, {
                                type: "button",
                                variant: "cancel",
                                className: clsx(canDeleteAll ? '!tw-text-alert-500' : '!tw-text-neutral-light-500 tw-opacity-50 tw-pointer-events-none'),
                                onClick: onDeleteAll,
                                children: [
                                    /*#__PURE__*/ jsx(Trash2, {
                                        size: 20,
                                        className: "tw-text-current"
                                    }),
                                    i18n[languageCode].DELETE_ALL
                                ]
                            })
                        ]
                    })
                ]
            }),
            footerActions
        ]
    });
}
export { ListActionsLayout };
